import styled from 'styled-components';

const ExamInfoPageContainer = styled.div`
  ${({ theme }) => theme.container.mainContainer}
`;

export { ExamInfoPageContainer };
